import {ChangeDetectorRef, Component, forwardRef, Injector, Input, ViewChild} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  FormControlDirective,
  NG_VALUE_ACCESSOR, ReactiveFormsModule
} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {isArray} from "ngx-bootstrap/chronos";
import {FormGroupComponent} from "../../form-inputs/form-group/form-group.component";
import {NgIf} from '@angular/common';

@Component({
    selector: 'app-int-filter',
    templateUrl: './int-filter.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => IntFilterComponent),
            multi: true,
        }
    ],
  imports: [FormGroupComponent, ReactiveFormsModule, NgIf],
    standalone: true
})
export class IntFilterComponent implements ControlValueAccessor {


  public formGroup = this.fb.group({
    min: this.fb.control<number | ''>(''),
    max: this.fb.control<number | ''>(''),
  })

  @Input() public placeholder = ''
  @Input() public label!: string

  @Input() public inline = true;
  @Input() public small = true;

  @Input() public name?: string;

  @ViewChild(FormControlDirective, {static: true})
  public formControlDirective?: FormControlDirective;

  @Input()
  public formControl?: FormControl<string[] | string | null>

  @Input()
  public formControlName!: string;

  public get control(): FormControl<string[] | string | null> {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <FormControl<string[] | string | null>>this.formControl ?? this.controlContainer.control.get(this.formControlName);
  }

  get controlContainer(): ControlContainer {
    return this.injector.get(ControlContainer);
  }

  registerOnTouched(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
  }

  registerOnChange(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnChange(fn);
  }

  writeValue(value: string[] | string | null): void {

    if (value && isArray(value) && value?.length === 2) {
      this.formGroup.patchValue({
        min: value[0] as unknown as number ?? '',
        max: value[1] as unknown as number ?? ''
      }, {emitEvent: false})
    } else if (value && typeof value === 'string' && value.includes(',')) {
      const split = value.split(',')
      this.formGroup.patchValue({
        min: split[0] as unknown as number ?? '',
        max: split[1] as unknown as number ?? ''
      }, {emitEvent: false})
    } else {
      this.formGroup.patchValue({
        min: '',
        max: ''
      }, {emitEvent: false})
    }
  }

  setDisabledState(): void {
    // da formControl und control identisch sind brauchen wir hier nichts weiter zu geben

  }

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly injector: Injector,
    private readonly translate: TranslateService,
    private fb: FormBuilder
  ) {
    this.formGroup.valueChanges.subscribe(
      v => {
        if (this.formGroup.valid) {

          if (!v.min && !v.max) {
            this.control.setValue('');
          } else {
            this.control.setValue((v.min ?? '') + ',' + (v.max ?? ''));
          }

        }

      }
    )
  }
}
